import React from "react";
import { ResponsiveContainer, AreaChart, Area, XAxis, Tooltip } from "recharts";
import { formatINR } from "./formatINR";

interface Props {
  amountPaise: number | null;
  changePct: number | null;
  series?: { day: string; amount: number }[];
}

export const RevenueTrendCard: React.FC<Props> = ({ amountPaise, changePct, series }) => {
  const blocked = amountPaise === null;
  const hasData = !!series && series.length > 0;

  return (
    <div className="rounded-2xl bg-white border border-slate-100 shadow-sm p-5 flex flex-col">
      <div className="flex items-start justify-between">
        <h3 className="text-sm font-semibold text-slate-900">Revenue Trend</h3>
        {!blocked && changePct !== null && changePct !== undefined && (
          <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-green-50 text-green-700 flex items-center gap-0.5">
            <span>↗</span>
            <span>+{changePct.toFixed(1)}%</span>
          </span>
        )}
        {blocked && (
          <span className="text-[10px] font-medium uppercase tracking-wide text-slate-400 bg-slate-100 px-2 py-0.5 rounded-full">
            Coming soon
          </span>
        )}
      </div>

      <p className="mt-3 text-2xl font-bold text-slate-900">
        {blocked ? "—" : formatINR(amountPaise!)}
      </p>
      <p className="text-xs text-slate-500">This month</p>

      <div className="mt-3 h-20">
        {hasData ? (
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={series} margin={{ top: 4, right: 0, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="revenueGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#10b981" stopOpacity={0.4} />
                  <stop offset="100%" stopColor="#10b981" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="day" axisLine={false} tickLine={false} tick={{ fontSize: 10, fill: "#94a3b8" }} />
              <Tooltip
                cursor={{ stroke: "#10b981", strokeWidth: 1, strokeDasharray: "3 3" }}
                contentStyle={{ fontSize: 11, borderRadius: 8, border: "1px solid #e2e8f0" }}
                formatter={(v) => formatINR(Number(v))}
              />
              <Area type="monotone" dataKey="amount" stroke="#10b981" strokeWidth={2} fill="url(#revenueGradient)" />
            </AreaChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-full flex items-center justify-center text-xs text-slate-400">
            {blocked ? "" : "No revenue recorded yet"}
          </div>
        )}
      </div>
    </div>
  );
};

export default RevenueTrendCard;
